export interface GameState {
  // Meta
  turn: number // 1-40 (10 years * 4 quarters)
  isGameOver: boolean
  gameStatus: 'playing' | 'bankrupt' | 'victory'

  // Resources
  cash: number
  revenue: number // Quarterly
  expenses: number // Quarterly
  netIncome: number // Quarterly

  // Team
  engineers: number
  sales: number

  // Product
  productQuality: number // 0-100

  // History for charts
  history: GameHistory[]
}

export interface GameHistory {
  turn: number
  cash: number
  revenue: number
  netIncome: number
  headcount: number
}

export interface Decisions {
  unitPrice: number
  newEngineers: number
  newSales: number
  salaryMultiplier: number // 0.6 - 1.4
}

export const INITIAL_STATE: GameState = {
  turn: 1,
  isGameOver: false,
  gameStatus: 'playing',
  cash: 1000000,
  revenue: 0,
  expenses: 0,
  netIncome: 0,
  engineers: 4,
  sales: 2,
  productQuality: 50,
  history: [
    {
      turn: 0,
      cash: 1000000,
      revenue: 0,
      netIncome: 0,
      headcount: 6,
    },
  ],
}

export const GAME_CONSTANTS = {
  MAX_TURNS: 40,
  BASE_SALARY_ENGINEER: 30000, // Quarterly
  BASE_SALARY_SALES: 25000, // Quarterly
  BASE_OPERATING_COST: 50000, // Quarterly fixed cost
  SALES_CAPACITY_PER_REP: 100, // Units per sales rep
  MARKET_DEMAND_BASE: 1000, // Base market demand
}
